import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { throttle } from 'lodash-es';
import { Modal, message } from 'antd';
import HTTP from '../script/service';
import Util from '../script/util';
import store from './store';
import rootConfig from '../script/config';
import WEBIM from './WebNim';
import WEBROOM from './WebRoom';

/**
 * 初始化服务域名
 * * @param isOffDomainReplace 是否关闭域名替换 默认 false 开启
 * */
export const _init_ctx_path = function (isOffDomainReplace = false) {
  return new Promise(async (resolve, reject) => {
    function save_root_config(path) {
      path = path || 'daidaidj.com';
      let new_config = {
        rootPath: path,
        basePath: 'daidaidj.com',
      };
      for (let i in rootConfig) {
        if (i !== 'loginUrl' && typeof rootConfig[i] == 'string') {
          new_config[i] = rootConfig[i].replace(
            new_config.basePath,
            new_config.rootPath
          );
        } else {
          new_config[i] = rootConfig[i];
        }
      }
      // 协议地址
      let hostname = window.location.hostname.split('.');
      if (process.env.NODE_ENV === 'development') {
        hostname = ['test-play', 'daidaidj', 'com'];
      }
      // 协议地址不跟随安全域名
      new_config['protocolPath'] = new_config.mobilePath.replace(
        new_config.rootPath,
        `${hostname[1]}.${hostname[2]}`
      );

      new_config.companyConfig = {
        companyName: '武汉盛游互娱网络科技有限公司',
        appName: '带带陪玩',
        email: 'daidai@shengyouhudong.com',
        record: '鄂ICP备2022000473号',
        address:
          '武汉市东湖新技术开发区光谷大道77号金融港后台服务中心二期B7栋10层01室',
      };
      if (rootConfig.lang != 'zh_CN') {
        new_config.companyConfig = {
          companyName: 'Century Network (Hong Kong) Limited',
          appName: '帶帶電競',
          email: 'daidai@shengyouhudong.com',
          address:
            'ROOM 6, 11/F, CHEUNG HING BUILDING, 540-544 NATHAN ROAD, YAU MA TEI, KOWLOON, HONG KONG',
        };
      } else if (new_config.rootPath == 'daidaicp.com') {
        new_config.companyConfig = {
          companyName: '武汉盛游互娱网络科技有限公司',
          appName: '带带电竞',
          email: 'daidai@shengyouhudong.com',
          record: '鄂ICP备2022000473号-3',
          address:
            '武汉市东湖新技术开发区光谷大道77号金融港后台服务中心二期B7栋10层01室',
        };
        document.title = document.title.replace(
          '带带陪玩',
          new_config.companyConfig.appName
        );
      }
      const action = {
        type: 'set_root_config',
        data: { rootConfig: new_config },
      };
      store.dispatch(action);
      resolve(new_config);
    }
    function send_error(error) {
      let {
        message,
        config: { url, method, params, data },
      } = error.toJSON();
      if (typeof params == 'string') params = qs.parse(params);
      if (typeof data == 'string') data = qs.parse(data);
      const sendError = {
        url,
        message,
        params: method == 'get' ? params : data,
      };
      if (error.response) {
        sendError['message'] = error.response.statusText;
        sendError['data'] = error.response.data;
      }
      console.error('接口错误：', sendError);
      _anly_seng_custom(1502, sendError);
    }
    // 测试环境使用默认配置
    let hostname = window.location.hostname.split('.');
    let url_1 =
      (!!isOffDomainReplace ? rootConfig.ctxPath : rootConfig.securityPath_1) +
      '/config/api/base/v2/dicts';
    let url_params = `source=${rootConfig.source}&hostName=${hostname[hostname.length - 2]}.${hostname[hostname.length - 1]}`;
    if (process.env.NODE_ENV === 'development') {
      url_params = `source=${rootConfig.source}&hostName=daidaidj.com`;
    }
    const headers = {
      source: rootConfig.source,
      vnum: rootConfig.vnum,
      version: rootConfig.version,
      companyCode: rootConfig.companyCode,
      appCode: rootConfig.companyCode,
      timestamp: Date.now(),
    };
    headers['X-Signature'] = await Util.cryptoParamsCode(
      headers,
      qs.parse(url_params)
    );
    axios
      .get(`${url_1}?${url_params}`, { headers })
      .then(async (res_1) => {
        res_1.data.data = await Util.decryptContent(
          res_1.data.data,
          res_1.config.url
        );
        if (res_1.data.code == 200 && res_1.data.data && res_1.data.data.path) {
          window.dicts = res_1.data;
          const { path } = res_1.data.data;
          if (path.apiUrl) rootConfig.ctxPath = path.apiUrl;
          if (path.imgPath) rootConfig.prefix = path.imgPath;
          if (path.baseVideoPath) rootConfig.baseVideoPath = path.baseVideoPath;
          save_root_config(path.live);
        }
      })
      .catch(async (err_1) => {
        send_error(err_1);
        let url_2 = `${rootConfig.securityPath_2}/config/api/base/v2/dicts`;
        axios
          .get(`${url_2}?${url_params}`, { headers })
          .then(async (res_2) => {
            res_2.data.data = await Util.decryptContent(
              res_2.data.data,
              res_2.config.url
            );
            if (
              res_2.data.code == 200 &&
              res_2.data.data &&
              res_2.data.data.path
            ) {
              window.dicts = res_2.data;
              const { path } = res_2.data.data;
              if (path.apiUrl) rootConfig.ctxPath = path.apiUrl;
              if (path.imgPath) rootConfig.prefix = path.imgPath;
              if (path.baseVideoPath)
                rootConfig.baseVideoPath = path.baseVideoPath;
              save_root_config(path.live);
            }
          })
          .catch((err_2) => {
            send_error(err_2);
            save_root_config();
          });
      });
  });
};

//获取经纬度
export const _get_point = (callback) => {
  /*let point = Util.readCookie('point');
    const { rootConfig } = store.getState();
    if (point) {
        const action = {
            type: 'set_point_value',
            data: { point: JSON.parse(point) }
        };
        Util.setCookie('point', point);
        store.dispatch(action);
        callback && callback();
    } else {
        if (rootConfig.lang == 'zh_CN') {
            HTTP._get_point_data()
                .then((res) => {
                    if (!res.content) {
                        res.content = {
                            address: '未知',
                            address_detail: {
                                city: '未知',
                                city_code: 0,
                                district: '',
                                province: '未知',
                                street: '',
                                street_number: '',
                            },
                            point: {
                                x: 0,
                                y: 0,
                            },
                        };
                    }
                    const action = {
                        type: 'set_point_value',
                        data: { point: res.content }
                    };
                    Util.setCookie('point', JSON.stringify(res.content));
                    store.dispatch(action);
                    callback && callback();
                })
                .catch(() => {
                    callback && callback();
                });
        } else {
            callback && callback();
        }
    }*/
  callback && callback();
};
//获取数据字典
export const _get_dicts = function (param) {
  return new Promise(function (resolve, reject) {
    function realyerData(res) {
      if (res.code == 200) {
        if (res.data.appLoginStatusConfig) {
          /**
           * todo 2022.03.25 客户端根据接口状态判断是否需要清除用户登录信息
           * status 开关 1 是  0 否
           * ver 数据版本号， 根据与上一次获取的对比 （上一次的数值存在本地 cookie（clear_version_num）中）
           * */
          const { status, ver } = res.data.appLoginStatusConfig;
          const localClearVersion = Util.readCookie('clear_version_num') || -1;
          const token = Util.readCookie('token');
          const uid = Util.readCookie('uid');
          if (status && ver > localClearVersion && token && uid) {
            message.warning('身份信息已过期，请重新登录');
            setTimeout(_clear_user_info.bind(this, true), 500);
          }
          Util.setCookie('clear_version_num', ver);
        }
        const { rootConfig } = store.getState();
        const action = {
          type: 'set_system_dicts',
          ...res.data,
          ctxPath: rootConfig.ctxPath,
          mobilePath: rootConfig.mobilePath,
        };
        store.dispatch(action);
        resolve(res.data);
      } else {
        _anly_seng_custom(1005, { data: res });
        if (window.location.href.indexOf('stick') == -1)
          window.location.href = `/stick${window.location.search}`;
      }
    }
    if (param) {
      realyerData(param);
    } else {
      HTTP._get_dicts_data().then((res) => {
        realyerData(res);
      });
    }
  });
};
//获取浏览器参数
export const _get_url_search = (callback) => {
  let search = window.location.search.replace('?', '');
  let params = {};
  if (search && search !== '') {
    params = qs.parse(search);
  }
  callback && callback(params);
};
//获取系统参数
export const _get_system_params = (callback) => {
  let search = window.location.search.replace('?', '');
  let params = {};
  const { rootConfig } = store.getState();
  if (search && search !== '') {
    const search_json = qs.parse(search);
    //渠道参数 异常处理
    if (search_json.channelId && typeof search_json.channelId != 'string') {
      search_json.channelId = null;
    }
    params = {
      channelId: search_json.channelId || rootConfig.channelId,
      dsid: search_json.dsid || null,
      jnid: search_json.jnid || null,
      roomid: search_json.roomid || null,
      scale: search_json.scale || null,
    };
  } else {
    params = {
      channelId: rootConfig.channelId,
    };
  }
  if (params.channelId == '1000') {
    let channelId = localStorage.getItem('channelId');
    if (channelId) params.channelId = channelId;
  }
  if (params.channelId != '1000') {
    localStorage.setItem('channelId', params.channelId);
  }
  //历史登录用户
  let uid = Util.readCookie('uid');
  let token = Util.readCookie('token');
  // let loginFrom = Util.readCookie('loginFrom');
  //允许自动登录
  if (uid && token) {
    params.uid = uid;
    params.token = token;
  }
  //是否首次进入
  params.firstIn = !Util.readCookie('firstIn');
  //获取登录方式
  params.register = Util.readCookie('register') || 1;
  //特殊版本记录
  if (params.channelId == '945CFBA47eZD') {
    rootConfig.clientCtxPath = '/win-download/update/DaiDaiDj_945CFBA47eZD.exe';
  } else if (params.channelId == '39383C9D5Rua') {
    rootConfig.clientCtxPath = '/win-download/update/DaiDaiDj_39383C9D5Rua.exe';
  } else if (params.channelId == 'PID2tzOPfAXj') {
    rootConfig.clientCtxPath = '/win-download/update/DaiDaiDj_PID2tzOPfAXj.exe';
  }
  store.dispatch({
    type: 'set_system_value',
    data: { ...params, rootConfig },
  });

  if (uid && token) {
    _get_point(() => {
      _get_user_info(
        {
          uid: uid,
          token: token,
          qKey: 'get_system_params',
        },
        (user) => {
          Util.delCookie('anonymous_account');
          callback && callback(user);
        }
      );
    });
  } else {
    _get_point(callback);
  }
};
//显示登录窗
export const _show_login_modal = (param) => {
  const action = {
    type: 'set_login_modal',
    data: { login_visible: true },
  };
  store.dispatch(action);
};
//隐藏登录窗
export const _hide_login_modal = () => {
  const action = {
    type: 'set_login_modal',
    data: { login_visible: false },
  };
  Util.setCookie('firstIn', true);
  store.dispatch(action);

  // 游客房间内关闭登录弹窗则退回至首页
  const base = store.getState();
  if (base?.uid == null && window.location.pathname === '/room') {
    window.location.href = `/index${window.location.search}`;
  }
};
//设置登录参数
export const _set_uid_token = (params) => {
  const action = {
    type: 'change_uid_token',
    ...params,
  };
  store.dispatch(action);
  //数据为空
  if (!params || !params.uid || !params.token) {
    _anly_seng_custom(1006, { params });
  }
  Util.setCookie('uid', params.uid);
  Util.setCookie('token', params.token);
  Util.setCookie('register', params.register);
  setTimeout(_upload_client_log_file, 1000);

  /* 盛典弹窗 */
  store.dispatch({
    type: 'change_show_annual_modal',
    data: { showAnnualModal: true },
  });
};
//统一获取用户资料
export const _get_user_info = (
  params = {},
  callback,
  isTgid = false,
  delay = 1
) => {
  let base = store.getState();
  if (!params.uid || !params.token) {
    params.uid = base.uid;
    params.token = base.token;
  }
  HTTP._get_user_data(params).then((res) => {
    if (res.code == 200 && res.data) {
      _dssp_login_user(base, isTgid);
      const action = {
        type: 'change_user_info',
        data: res.data,
      };
      store.dispatch(action);
      //重新获取最新 base内容
      base = store.getState();
      if (res.data.imUsername && !base.webim.conn) {
        try {
          WEBIM.openConn(res.data, base);
          //连接直播间
          /*if (WEBROOM.conn) {
                        _webroom_connect_room()
                    }*/
          // 由于限制游客进入房间，则此处判断改为通过路由的方式 todo 2.25.0 2023-08-31
          const roomid = Util.getParameters('roomid');
          if (
            !!roomid &&
            window.location.pathname === '/room' &&
            WEBROOM?.isAnonymousRoom &&
            WEBROOM.conn === null
          ) {
            _webroom_connect_room(roomid);
          }
        } catch (error) {
          _anly_seng_custom(1003, { data: error });
        }
      } else if (!res.data.imUsername) {
        //注册IM账号
        setTimeout(() => {
          _get_nim_detail(
            {
              uid: res.data.uid,
            },
            (user) => {
              try {
                WEBIM.openConn(user, base);
                //连接直播间
                if (WEBROOM.conn) {
                  _webroom_connect_room();
                }
              } catch (error) {
                _anly_seng_custom(1003, { data: error });
              }
            }
          );
        }, 2000);
      }
      Util.setCookie('room-popover', true);
      if (window.century_setting) {
        window.century_setting['uid'] = base.uid;
        window.century_setting['channelId'] = base.channelId;
      }
      //重新更新账户信息
      if (WEBIM.userInfo) WEBIM.userInfo = { ...res.data };
      //判断是否获取特权配置
      if (
        (res.data.wealthAmount && !base.wealthConfig) ||
        res.data.wealthAmount >= 200000000
      ) {
        _get_wealth_config({ uid: params.uid });
      }
      // 获取用户是否有开黑大厅入口/创建开黑房房间的权限
      _get_user_is_black_room(base.uid);
      callback && callback(res.data);

      if (window._monitor_?.main?.updateConfigExtends) {
        window._monitor_.main.updateConfigExtends("uid", base.uid)
      }
    }
    //未找到，延迟查询3次
    else if (res.code == 408 && delay < 3) {
      setTimeout(() => {
        _get_user_info(params, callback, isTgid, ++delay);
      }, 1000);
    } else {
      params.delay = delay;
      _anly_seng_custom(1002, { data: res, params });
      _clear_user_info();
      callback && callback();
    }
  });
};
//统一获取用户亲密关系
export const _get_user_affinity_info = (params = {}, callback) => {
  let base = store.getState();
  if (!params.searchUid) {
    params.searchUid = base.uid;
  }
  HTTP._get_affinity_details(params).then((res) => {
    if (res.code == 200 && res.data) {
      _set_affinity_data({ affinityData: res.data });
      callback && callback(res.data);
    }
  });
};
//获取财富权限配置
export const _get_wealth_config = (param, callback) => {
  HTTP._get_wealth_set(param).then((res) => {
    if (res.code == 200) {
      const action = {
        type: 'set_wealth_config',
        data: { wealthConfig: res.data || {} },
      };
      store.dispatch(action);
      callback && callback(res.data);
    }
  });
};
//获取网易账号
export const _get_nim_detail = (params, callback) => {
  HTTP._get_nim_detail({
    uid: params.uid,
  }).then((res) => {
    if (res.code == 200) {
      let base = store.getState();
      base.userInfo['imNickname'] = res.data.nickname;
      base.userInfo['imUsername'] = res.data.username;
      base.userInfo['impassword'] = res.data.password;
      const action = {
        type: 'change_user_info',
        data: { ...base.userInfo },
      };
      store.dispatch(action);
      callback && callback(base.userInfo);
    } else {
      message.error(res.message);
      _anly_seng_custom(1004, { data: res });
    }
  });
};
//登录上传
export const _dssp_login_user = (base, isTgid = false) => {
  if (base.webim && base.webim.conn) {
    return false;
  }
  let register = Util.readCookie('register'); //1:微信 2:QQ 3:手机

  const param = {
    ykid: Util.readCookie('anonymous_account') || '',
  };
  if (isTgid && base.clientInfo) {
    param.tgid = base.clientInfo.tgid || '';
  }
  if (register == 2) {
    _dssp_send_click(13, param);
  } else if (register == 3) {
    _dssp_send_click(15, param);
  } else {
    _dssp_send_click(14, param);
  }
};
//注销
export const _clear_user_info = (re) => {
  return new Promise((resolve, reject) => {
    const action = {
      type: 'clear_user_info',
    };
    store.dispatch(action);
    _change_verified_real_name();
    Util.delCookie('uid');
    Util.delCookie('token');
    Util.delCookie('register');
    Util.delCookie('hide_tip_prefect'); // 清除是否展示用户信息完善提示
    Util.delCookie('enter_room_info'); // 清除进房间跟随
    window.sessionStorage.clear();
    const dd_annual_show = window.localStorage.getItem('dd_annual_show'); // 盛典所需 - 临时代码
    window.localStorage.clear();
    if (dd_annual_show != null)
      window.localStorage.setItem('dd_annual_show', dd_annual_show); // 盛典所需 - 临时代码
    if (re) {
      window.location.reload();
    } else {
      if (WEBIM.conn && WEBIM.nim.disconnect) WEBIM.nim.disconnect();
      if (WEBROOM.conn) _webroom_connect_room();
    }
    resolve();
  });
};
//验证token index 第几次验证token
export const _check_login_token = (token, type, callback, index = 0) => {
  Util.setCookie('hideNewPop', true);
  const { syUserLoginInfo } = store.getState();
  const params = {
    token: token,
    register: type,
    ...(syUserLoginInfo ? syUserLoginInfo : {}), // 只有迁移是需要添加此字段
  };
  const bdVid = Util.getParameters('bd_vid');
  // showUrl 上报
  if (bdVid) {
    params['showUrl'] = encodeURIComponent(window.location.href);
  }
  const urlType = '_check_token_sy';
  HTTP[urlType](params).then((res) => {
    if (res.code == 200) {
      Util.delCookie('enter_room_info'); // 清除进房间跟随
      Util.delCookie('anonymous_account'); //清除游客账号
      _set_uid_token({
        uid: res.data.uid,
        token: res.data.accessToken,
        register: type,
        qKey: 'check_login_token',
      });
      _get_user_info(
        {
          uid: res.data.uid,
          token: res.data.accessToken,
          qKey: 'check_login_token',
        },
        () => {
          if (!!res.data) {
            store.dispatch({
              type: 'set_is_new_user_info',
              data: { isNewUserInfo: res.data },
            });
            if (!!res.data.isBindPhone && !res.data.bindPhone) {
              _change_phone_modal(true, false);
            } else if (index === 2) {
              // 展示身份验证通过弹窗
              _change_sy_secondary_auth_success(true);
            } else {
              _is_new_process();
            }
            Util.delCookie('anonymous_account');
            callback && callback(null);
          } else {
            callback && callback(res.data);
          }
        },
        true
      );
    } else if (res.code === 3331) {
      // 用户存在，需要绑定手机号
      _change_sy_user_login_info(res.data);
      _change_sy_phone_modal(true);
    } else if (res.code === 3332) {
      // 用户中心查询用户信息异常，请稍后再试!
      _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
      message.warning(res.message, 10);
    } else if (res.code === 3335) {
      // 用户会话已过期重新授权登录
      _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
      _show_login_modal();
      message.warning(res.message, 10);
    } else if (res.code === 3336) {
      // 用户需验证手机号
      _change_sy_phone_modal(true);
      message.warning(res.message, 10);
    } else if (res.code === 3337) {
      // 用户注册来源不匹配
      _show_login_modal();
      _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
      message.warning(res.message, 10);
    } else if (res.code === 3338) {
      // 用户信息校验失败 需要用户使用相同的登录账号
      const type =
        syUserLoginInfo && syUserLoginInfo.register === 1 ? 'wx' : 'qq';
      _change_sy_user_login_info(res.data);
      _change_sy_secondary_auth_error({ [type]: true });
      message.warning(res.message, 10);
    } else if (res.code === 3339) {
      // 用户手机号不匹配
      _change_sy_user_login_info(res.data);
      _change_sy_secondary_auth_error({ phone: true });
      message.warning(res.message, 10);
    } else if (res.code === 3340) {
      // 账号封禁
      _show_account_abnormal_modal(res);
    } else {
      _change_sy_user_login_info(null); // 用户迁移 - 清除用户信息
      message.error(res.message, 10);
      _anly_seng_custom(1001, { data: res, params });
    }
  });
};
//NIM退出
export const _nim_dis_connect = (callback) => {
  store.dispatch({
    type: 'nim_dis_connect',
    data: { webim: {} },
  });
  callback && callback();
};
//订阅变更
export const _nim_update_multi_status = (data) => {
  const action = {
    type: 'nim_update_multi_status',
    data,
  };
  store.dispatch(action);
};
//更新回话列表
export const _nim_change_session = (sessions) => {
  const action = {
    type: 'nim_change_session',
    sessions: sessions,
  };
  store.dispatch(action);
};
//NIM同步
export const _nim_sync_done = (param) => {
  const action = {
    type: 'nim_sync_done',
    data: param,
  };
  store.dispatch(action);
};
//显示即时通讯窗口
export const _change_nim_chat = (param) => {
  const action = {
    type: 'change_nim_chat',
    data: param,
  };
  //关闭聊天窗口
  if (!param) {
    WEBIM.resetCurrChat();
  } else {
    if (param?.to?.account) {
      _dssp_send_click(91, {
        to: Util.$analyToUid(param.to.account),
        origin: param.origin,
      });
    }
  }
  store.dispatch(action);
};
//获取客户端资料
export const _get_client_info = () => {
  return new Promise((resolve, reject) => {
    if (window.eleEvents) {
      window.eleEvents
        .getClientConfig()
        .then((res) => {
          const action = {
            type: 'set_client_electron_info',
            data: res,
          };
          store.dispatch(action);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      Util.$interface(
        '_get_client_info',
        {},
        '_get_client_info',
        (obj) => {
          const action = {
            type: 'set_client_info',
            data: obj,
          };
          store.dispatch(action);
          resolve(obj);
        },
        (err) => reject(err)
      );
      //先退出一次直播间
      Util.$interface('_nim_leave_room');
      Util.$interface('_release_agora_client');
    }
  });
};
//打开个人中心
export const _open_my_center = (param) => {
  const { uid, token } = store.getState();
  if (!uid || !token) {
    _show_login_modal();
    return;
  }
  const action = {
    type: 'open_my_center',
    data: { myModal: param },
  };
  store.dispatch(action);
  if (param) {
    const origin = param?.origin || 'other';
    _dssp_send_click(75, { ...param, origin });
  }
};
//显示大神主页
export const _change_ds_modal = (param) => {
  const { uid, token } = store.getState();
  if (!uid || !token) {
    _show_login_modal();
    return;
  }
  const action = {
    type: 'change_ds_modal',
    data: { dsModal: param },
  };
  store.dispatch(action);
  if (param) {
    const origin = param?.origin || 'other';
    _dssp_send_click(72, { ...param, origin });
  }
};
//显示下单主页
export const _change_order_modal = (param) => {
  const action = {
    type: 'change_order_modal',
    data: { dsOrder: param },
  };
  store.dispatch(action);
};
//设置亲密关系数据
export const _set_affinity_data = (param) => {
  const action = {
    type: 'set_affinity_data',
    data: { ...param },
  };
  store.dispatch(action);
};
//显示亲密关系弹窗
export const _change_affinity_modal = (param) => {
  const action = {
    type: 'change_affinity_modal',
    data: { ...param },
  };
  store.dispatch(action);
};
//显示点单弹窗
export const _change_speed_order_modal = (param) => {
  const action = {
    type: 'change_speed_order_modal',
    data: { ...param },
  };
  store.dispatch(action);
};
//直播间打开链接
export const _room_sync_done = () => {
  const action = {
    type: 'room_sync_done',
  };
  store.dispatch(action);
};
//直播间断开链接
export const _room_dis_connect = () => {
  const action = {
    type: 'room_dis_connect',
  };
  store.dispatch(action);
};
//直播消息更新
export const _room_change_message = () => {
  const action = {
    type: 'room_change_message',
  };
  store.dispatch(action);
};
//服务异常上报
export const _anly_seng_custom = (event, param = {}, options = null) => {
  //新版本数据上报
  if (window.anlySDK && window.anlySDK.eportParams) {
    const { channelId, uid, client, rootConfig, userInfo } = store.getState();
    param['userInfo'] = userInfo;
    param['channelId'] = channelId;
    param['accid'] = param.uid || uid;
    param['roomId'] = WEBROOM.roomid;
    param['clientType'] = client;
    param['clientVersion'] = rootConfig.version;
    param['keywords'] = event || 'LOG';
    window.anlySDK.eportParams(param);
  }

  // 每次自定义上报更新最新的拓展信息
  if (window._monitor_?.main?.updateConfigExtends) {
    const { channelId, uid, client, rootConfig, clientInfo } = store.getState();
    uid && window._monitor_.main.updateConfigExtends("uid", uid);
    window._monitor_.main.updateConfigExtends("channelId", channelId);
    window._monitor_.main.updateConfigExtends("client", client);
    window._monitor_.main.updateConfigExtends("source", 1);
    window._monitor_.main.updateConfigExtends("version", rootConfig.version);
    clientInfo?.version && window._monitor_.main.updateConfigExtends("clientVersion", clientInfo.version);
  }
  if (window._monitor_?.customPlugin?.customReport) {
    const { uid } = store.getState();
    window._monitor_.customPlugin.customReport(event || "LOG", {
      uid: param.uid || uid,
      roomid: WEBROOM.roomid,
      ...param,
    }, options);
  }
};
//dssp上报
export const _dssp_send_click = (event, param) => {
  //新版本数据上报
  if (window.ST && window.ST.webTJ) {
    window.ST.webTJ.customEvent('customevent', {
      label: event,
      action: param ? JSON.stringify(param) : '',
    });
  }
};
// 心跳参数修改
const _dssp_heart_param = throttle(
  () => {
    // 获取 visibilitychange
    // console.info("-----dssp_heart_param---", document.visibilityState);
  },
  4000,
  { leading: false }
);
/**
 * dssp 主动上报
 * @param param {Object}
 * @param param.page_name {String} 页面名称
 * @param param.tab_name {String} tab名称
 * @param param.sub_tab_name {String} 子页签名称
 * @param param.scene_category {String} 场景类型
 * @param param.scene_name {String} 场景名称
 * @param param.scene_value {Object} 自定义场景参数
 * */
export const _dssp_show_event = (param) => {
  if (window.ST && window.ST.webTJ) {
    const pageVisible = document.visibilityState === 'visible' ? 0 : 1;
    const defaultParam = {
      page_url: window.location.href, // 当前页面URL
      is_room_small: pageVisible, // 当前页面是否被隐藏 0: 否 1：是
    };
    window.ST.webTJ.customEvent('show', { ...param, ...defaultParam });

    _dssp_heart_param();
  }
};
//dssp 页面打开上报
export const _dssp_open_page = (location) => {
  //新版本数据上报
  if (window.ST && window.ST.webTJ && location) {
    const { origin } = window.location;
    const url = `${origin}${location.pathname}${location.search}`;
    window.ST.webTJ.pageviewstart({
      referrer_url: url, // 前向页面地址, 单页形式下，document.referrer 取值不准确， url 地址不要 encode
      page_name: document.title, //业务自定义
    });
  }
};
//dssp 页面结束上报
export const _dssp_close_page = (location) => {
  //新版本数据上报
  if (window.ST && window.ST.webTJ && location) {
    const { origin } = window.location;
    const url = `${origin}${location.pathname}${location.search}`;
    window.ST.webTJ.pageviewend({
      referrer_url: url, // 前向页面地址, 单页形式下，document.referrer 取值不准确， url 地址不要 encode
      page_name: document.title, //业务自定义
    });
  }
};
//进入直播间
export const _new_room_window = (
  param,
  history,
  callback,
  joinRoomType = null
) => {
  if (!param || !param.roomid) {
    callback && callback();
    return;
  }

  function joinRoom() {
    const bdVid = Util.getParameters('bd_vid'); // 百度广告专属字段
    const base = store.getState();
    const scale = base.scale ? `&scale=${base.scale}` : '';
    const bdVidParam = bdVid ? `&bd_vid=${bdVid}` : '';
    if (WEBROOM.conn) {
      _webroom_connect_room(
        param.roomid,
        param.roomname,
        () => {
          callback && callback();
        },
        joinRoomType
      );
    }
    //未完成前一个房间的密码验证
    else if (WEBROOM.confirmPwd) {
      _webroom_connect_room(
        param.roomid,
        param.roomname,
        () => {
          callback && callback();
        },
        joinRoomType
      );
    }
    //web端 路由跳转
    else if (history) {
      const location = {
        search: `?roomid=${param.roomid}&channelId=${base.channelId}${scale}${bdVidParam}`,
        pathname: '/room',
      };
      if (!!joinRoomType) {
        Util.setCookie('enter_room_info', joinRoomType);
      }
      history.push(`${location.pathname}${location.search}`);
      callback && callback();
    }
    //web端 地址跳转
    else {
      const location = {
        search: `?roomid=${param.roomid}&channelId=${base.channelId}${scale}${bdVidParam}`,
        pathname: '/room',
      };
      if (!!joinRoomType) {
        Util.setCookie('enter_room_info', joinRoomType);
      }
      window.location.href = `${location.pathname}${location.search}`;
    }
  }

  if (WEBROOM.roomid == param.roomid && WEBROOM.conn) {
    joinRoom();
    return;
  }
  let password = localStorage.getItem('pwd_' + param.roomid);
  if (password) {
    joinRoom();
    return;
  }
  _get_room_is_has_pwd({
    roomid: param.roomid,
  }).then((res) => {
    if (res.ifRoomPassword) {
      if (res.ifRoomPasswordTrue) {
        joinRoom();
      } else {
        _change_confirm_room_pwd_modal(param.roomid);
      }
    } else {
      joinRoom();
    }
  });
};
// 进入房间 / 重载房间
export const _webroom_connect_room = (
  roomid = null,
  roomname = null,
  callback = null,
  joinRoomType = null
) => {
  const { uid } = store.getState();
  if (uid != WEBROOM.uid) {
    const search = window.location.search;
    const searchJson = qs.parse(search.replace('?', ''));
    searchJson.roomid = roomid;
    window.location.href = `/room?${qs.stringify(searchJson)}`;
    return;
  }
  WEBROOM.reload(
    roomid,
    roomname,
    () => {
      store.dispatch({
        type: 'change_select_user',
        data: { selectGiveUser: [] },
      });

      const { search, origin, pathname } = window.location;
      const searchText = search.replace('?', '');
      if (!!searchText) {
        const searchJson = qs.parse(searchText);
        searchJson.roomid = roomid;
        const location = {
          search: `?${qs.stringify(searchJson)}`,
          pathname,
        };
        const url = `${origin}${pathname}${location.search}`;
        window.history.replaceState({}, document.title, url);
      }
      callback && callback();
    },
    joinRoomType
  );
};
// 全局验证房间密码
export const _change_confirm_room_pwd_modal = (bool) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'change_confirm_room_pwd_modal',
      data: { confirmRoomPwd: bool },
    };
    store.dispatch(action);
    resolve();
  });
};
//验证房间是否需要密码
export const _get_room_is_has_pwd = (param) => {
  return new Promise(function (resolve, reject) {
    HTTP._if_room_password(param).then((res) => {
      if (res.code == 200) {
        resolve(res.data);
      } else {
        message.error(res?.message || '异常，请稍候重试');
        reject(res);
      }
    });
  });
};
//进入P2P对话窗
export const _new_nim_window = (param) => {
  if (!WEBIM.conn) {
    _show_login_modal();
    return false;
  }
  if (param && param.id) {
    WEBIM.setToUser(param);
  } else {
    WEBIM.setToUser();
  }
};
//窗口类型
export const _get_window_type = (param) => {
  let name = window.location.pathname;
  if (name.indexOf('/room') != -1) {
    param && param.room && param.room();
    return 'room';
  } else if (name.indexOf('/nim') != -1) {
    param && param.nim && param.nim();
    return 'nim';
  } else {
    param && param.main && param.main();
    return 'main';
  }
};
//nim消息黑名单
export const _nim_block_msg = (text) => {
  const base = store.getState();
  let arr = base.blackList.filter((item) => text.indexOf(item) != -1);
  return arr.length > 0 ? true : false;
};
//关闭手机绑定
export const _change_phone_modal = (visible = false, close = true) => {
  const action = {
    type: 'change_phone_modal',
    data: { visible, close },
  };
  store.dispatch(action);
};
// 用户迁移 - 显示/关闭手机绑定
export const _change_sy_phone_modal = (visible = false) => {
  const action = {
    type: 'change_sy_phone_modal',
    data: visible,
  };
  store.dispatch(action);
};
//设置备注
export const _change_remark_modal = (param) => {
  const action = {
    type: 'change_remark_modal',
    data: param,
  };
  store.dispatch(action);
};
//刷新列表
export const _refresh_nim_session = (param) => {
  const action = {
    type: 'refresh_nim_session',
    data: param,
  };
  store.dispatch(action);
};
//开关设置密码
export const _change_pwd_modal = (param) => {
  const action = {
    type: 'change_pwd_modal',
    data: param,
  };
  store.dispatch(action);
};
//举报
export const _tip_off = (param) => {
  const base = store.getState();
  if (param == null) {
    store.dispatch({
      type: 'change_global_iframe_visible',
      data: { globalIframe: { visible: false } },
    });
    return;
  }
  if (!base.userInfo) {
    _show_login_modal();
    return false;
  }
  /*const action = {
        type: 'change_tip_off',
        data: param ? {
            uid: base.uid,
            ...param,
        } : null,
    };
    store.dispatch(action);*/
  /**
   * type 举报类型 1-填写工单 2-工单列表 3-工单详情
   * reportType 举报类型 1-用户 2-房间
   * reportedPersonId 被举报人id
   * reportOrderId 工单id
   * */
  let params = { uid: base.uid };
  params = { ...params, ...param };
  HTTP._get_report_jump_order_url(params).then((res) => {
    if (res?.code === 200) {
      store.dispatch({
        type: 'change_global_iframe_visible',
        data: {
          globalIframe: {
            visible: true,
            url: `${res.data.workOrderUrl}&isMobile=1`,
          },
        },
      });
    } else {
      message.error(res?.message || '打开失败，请稍后重试哦~');
    }
  });
};
//奖励弹窗
export const _show_award_modal = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'show_award_modal',
      data: param,
    };
    store.dispatch(action);
    resolve(param);
  });
};
//奖励弹窗
export const _hide_award_modal = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'hide_award_modal',
      data: { award_visible: false },
    };
    store.dispatch(action);
    resolve();
  });
};
// 打开新手礼包弹窗
export const _show_coupon_modal = () => {
  return new Promise(function (resolve, reject) {
    const base = store.getState();
    const uid = base.uid ? base.uid : null;
    if (uid) {
      const params = { uid };
      HTTP._get_new_user_reg_pack_list(params).then((res) => {
        if (res.code === 200) {
          store.dispatch({
            type: 'set_coupon_data',
            data: { coupon_data: res.data },
          });
          store.dispatch({
            type: 'show_new_user_coupon',
            data: { coupon_visible: true },
          });
          resolve();
        } else {
          // 查询是否需要弹出完善资料弹窗
          _is_show_perfect();
        }
      });
    }
  });
};
// 关闭新手礼包弹窗 param 是否登录状态
export const _hide_coupon_modal = () => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'hide_new_user_coupon',
      data: { coupon_visible: false },
    };
    store.dispatch(action);

    // 新用户领取完新人礼包需重置新人字段
    const base = store.getState();
    const stepInfo = base.stepInfo ? base.stepInfo : {};
    store.dispatch({
      type: 'set_step_info',
      data: { stepInfo: { ...stepInfo, isNew: false } },
    });
    // 实名认证
    _change_verified_real_name(false);
    resolve();
  });
};
//联系客服
export const _link_kf = (param = {}) => {
  return new Promise(function (resolve, reject) {
    _dssp_send_click(10);
    const base = store.getState();
    if (!!base.uid && !!base.token) {
      const CLIENT_ENV = process.env.CLIENT_ENV;
      let url = '';
      switch (CLIENT_ENV) {
        case 'development':
          url = 'https://kf-im-test.shengtian.com/pc';
          break;
        case 'demonstration':
          url = 'https://kf-im-pre.shengtian.com/pc';
          break;
        case 'production':
          url = 'https://kf-im.shengtian.com/pc';
          break;
        default:
          url = 'https://kf-im.shengtian.com/pc';
          break;
      }
      HTTP._get_custom_service()
        .then((res) => {
          if (res && res.code === 200) {
            param.token = res.data.token;
            const href = `${url}?${qs.stringify(param)}`;
            window.open(href);
            resolve();
          } else {
            const errorText =
              ((res && res.message) || '获取客服接口失败 ') +
              '/user/api/customer/v2/userLogin';
            console.error(errorText);
            message.error('打开失败，请稍后重试~');
            reject(errorText);
          }
        })
        .catch((err) => {
          console.error(err);
          message.error('打开失败，请稍后重试~');
          reject('打开失败，请稍后重试~');
        });
    } else {
      _show_login_modal();
      message.error('请登陆后再联系客服~');
      reject('请登陆后再联系客服~');
    }
  });
};
//浏览器不兼容
export const _show_browser_warn = (bool) => {
  store.dispatch({
    type: 'show_browser_warn',
    data: {
      browser_warn_vibale: bool || false,
    },
  });
};
// 展开步骤弹窗
export const _show_step_modal = (isNew = false) => {
  const base = store.getState();
  const nickName = base.userInfo ? base.userInfo.nickname : null;
  const action = {
    type: 'set_step_info',
    data: { stepInfo: { nickName, index: 0, isNew } },
  };
  store.dispatch(action);
  store.dispatch({ type: 'show_step_modal', data: { step_visible: true } });
};
// 是否完善用户信息
export const _is_show_perfect = (isNextRed = false) => {
  let isShowVerified = false; // false 展示 true 不展示;
  const base = store.getState();
  const hideTipPrefect = Util.readCookie('hide_tip_prefect');
  if (base && base.uid && !hideTipPrefect) {
    const params = { uid: base.uid };
    HTTP._get_user_info_complete_status(params).then((res) => {
      if (res && res.code === 200) {
        if (!!res.data) {
          // 由于需要展示红人推荐，则无须弹出实名认证弹窗
          if (isNextRed) {
            isShowVerified = true;
          }
          Util.setCookie('hide_tip_prefect', true);
        }
        _change_verified_real_name(isShowVerified);
        store.dispatch({
          type: 'set_is_show_perfect',
          data: { isShowPerfect: !res.data },
        });
      }
    });
  }
};
export const _register_call = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'register_call',
      data: param,
    };
    store.dispatch(action);
    resolve(param);
  });
};
export const _emit_call = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'emit_call',
      data: param,
    };
    store.dispatch(action);
    resolve(param);
  });
};
export const _show_medal_get = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'show_medal',
      data: param,
    };
    store.dispatch(action);
    resolve(param);
  });
};
export const _hide_medal_get = (param) => {
  return new Promise(function (resolve, reject) {
    const action = {
      type: 'hide_medal',
      data: param,
    };
    store.dispatch(action);
    resolve(param);
  });
};
export const _get_client_down_url = () => {
  return new Promise((resolve) => {
    const {
      rootConfig: { rootPath, clientCtxPath },
      uid,
    } = store.getState();
    const fileUrl = '//down.' + rootPath + clientCtxPath;
    const r = /https?:\/\/[^/]+(\/[^?#]*\.exe)/;
    const suffix = `https:${fileUrl}`.match(r)?.[1] || null;
    HTTP._get_client_download_sign({ uri: suffix, uid })
      .then((res) => {
        if (res?.code === 200) {
          resolve(`${fileUrl}?auth_key=${res.data.sign}`);
        } else {
          resolve(fileUrl);
        }
      })
      .catch((err) => {
        console.error('---err---', err);
        resolve(fileUrl);
      });
  });
};
export const _h5_link_to = (url) => {
  return new Promise(function (resolve, reject) {
    if (!url) {
      reject();
      return;
    }
    const { rootConfig, uid, token, channelId, userInfo } = store.getState();
    let search = url.split('?');

    let params = {};
    if (search[1] && search[1] !== '') {
      params = { ...params, ...qs.parse(search[1]) };
    }
    if (userInfo) {
      params.uid = uid;
      params.token = token;
    }
    params.channelId = channelId;
    params.v = rootConfig.version;
    let urlPath = search[0];
    if (urlPath.indexOf('http://') == -1 && urlPath.indexOf('https://') == -1) {
      urlPath = rootConfig.mobilePath + urlPath;
    }
    resolve({
      url: urlPath.trim(),
      params: params,
    });
  });
};
// 展示关闭身份绑定
export const _change_bind_cert_modal = (param) => {
  const action = {
    type: 'change_bind_cert_modal',
    data: { bindCert_visible: param },
  };
  store.dispatch(action);
};
// 展示大神入驻
export const _show_god_end_visible = (bool) => {
  HTTP._get_join_god_switch()
    .then((res) => {
      if (res && res.code === 200 && res.data.switchStatus == 1) {
        const action = {
          type: 'change_god_end_visible',
          data: { godEnter_visible: bool },
        };
        store.dispatch(action);
      } else {
        message.warning(
          (res && res.data && res.data.pcMessage) || '功能正在维护中~'
        );
      }
    })
    .catch((err) => {
      message.warning('功能正在维护中~');
    });
};
// 是否需要展示实名认证弹窗
export const _change_verified_real_name = (bool = true) => {
  let isShow = false;
  if (!bool) {
    const base = store.getState();
    HTTP._get_certification_info({ uid: base.uid }).then((res) => {
      if (res.code == 200) {
        isShow = !!res?.data;
        store.dispatch({
          type: 'set_is_verified_real_name',
          data: { isVerifiedRealName: isShow },
        });
      }
    });
  } else {
    store.dispatch({
      type: 'set_is_verified_real_name',
      data: { isVerifiedRealName: true },
    });
  }
};
// 保存每一步登录的信息
export const _change_sy_user_login_info = (data) => {
  const action = {
    type: 'set_sy_user_login_info',
    data,
  };
  store.dispatch(action);
};
// 登录错误提示弹窗
export const _change_sy_secondary_auth_error = (data) => {
  const { sySecondaryAuthError } = store.getState();
  const action = {
    type: 'set_sy_secondary_auth_error',
    data: { ...sySecondaryAuthError, ...data },
  };
  store.dispatch(action);
};
// 登录成功提示弹窗
export const _change_sy_secondary_auth_success = (data = false) => {
  const action = {
    type: 'set_sy_secondary_auth_success',
    data,
  };
  store.dispatch(action);
};
// 检测是否需要弹出新手流程 data 用户信息
export const _is_new_process = (data = null) => {
  let { isNewUserInfo, userInfo, dsid, jnid } = store.getState();
  if (!!data) isNewUserInfo = data;
  if (!!isNewUserInfo) {
    if (isNewUserInfo.isNew) {
      _show_step_modal(isNewUserInfo.isNew);
    } else {
      // 查询是否需要弹出完善资料弹窗
      _is_show_perfect();
    }
  } else {
    // todo 由于只有登录才能查看用户信息，所以当用户登录完成后展示
    if (userInfo && dsid) {
      _change_ds_modal({ dsid: dsid, jnid: jnid, ehot: false });
    }
  }
};
// 客户端日志上传
export const _upload_client_log_file = () => {
  if (!window.anlySDK) {
    setTimeout(_upload_client_log_file, 1000);
    return;
  }
  const { channelId, uid, client, clientInfo, userInfo } = store.getState();
  let upLogSize = 1024;
  let vvv = '0';
  if (clientInfo.version) vvv = parseInt(clientInfo.version.replace(/\./g, ''));
  //走PC客户端日志上传
  if (window.eleEvents && window.eleEvents.uploadLogFiles && vvv >= 310) {
    upLogSize = 0;
    window.eleEvents.uploadLogFiles({
      ...clientInfo,
      channelId,
      clientType: client,
      roomId: WEBROOM.roomid,
      accid: uid,
      deviceId: window.anlySDK ? window.anlySDK.deviceId : '',
    });
  }
  window.anlySDK.setParams &&
    window.anlySDK.setParams({
      appKey: '0073381759',
      userInfo,
      channelId,
      clientType: client,
      clientVersion: rootConfig.version,
      roomId: WEBROOM.roomid,
      accid: uid || 'NULL',
      upLogSize,
    });
  console.log('=> anlySDK.setParams end');
};
// nim连接状态
export const _sync_nim_connect = (param) => {
  const action = {
    type: 'sync_nim_connect',
    data: { nimConnState: param },
  };
  store.dispatch(action);
};
// 展示账户异常弹窗
export const _show_account_abnormal_modal = (res) => {
  if (res?.data?.content) {
    const { content } = res.data;
    let message = content;
    // 组装文案 方便后期通用文案
    const arr = content.match(/\{.+?\}/g);
    if (arr?.length) {
      arr.forEach((n) => {
        let word = n.match(/\w+/);
        if (word?.length) {
          word = word[0];
          if (n === '{text}') {
            message = message.replace(
              n,
              `<a target="_blank" href="${res.data.kfUrl}">${res.data[word]}</a>`
            );
          } else {
            message = message.replace(n, res.data[word]);
          }
        }
      });
    }
    const okText = res?.data?.text || '填写工单';
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      className: 'daidai-confirm-style login-error-modal',
      centered: true,
      content: <div dangerouslySetInnerHTML={{ __html: message }} />,
      okText: okText,
      cancelText: '我知道了',
      onOk: () => {
        store.dispatch({
          type: 'change_global_iframe_visible',
          data: {
            globalIframe: {
              visible: true,
              url: res.data.kfUrl,
              params: { zIndex: 1011 },
            },
          },
        });
      },
      zIndex: 1010,
    });
  } else {
    message.warning(res?.message ?? '账户异常，具体问题请联系客服');
  }
};
// 设置 redux 中当前房间号
export const _set_store_roomid = (roomid = null) => {
  store.dispatch({ type: 'set_new_roomid', data: { roomid } });
};

// 安全码验证信息
export const _set_safe_verify_data = (visible, config = null) => {
  store.dispatch({
    type: '_set_safe_verify_data',
    data: {
      safeVerifyConfig: {
        visible, // 是否展示弹窗
        config, // 请求拦截器中的数据
      },
    },
  });
};

// 获取用户的是否有开黑房的权限
export const _get_user_is_black_room = (uid, callback, isRefresh = false) => {
  if (!uid) {
    callback && callback(false);
    return;
  }
  const { isBlackRoom } = store.getState();
  if (isBlackRoom == null || isRefresh) {
    HTTP._if_create_game_room({ uid })
      .then((res) => {
        const isBlackRoom = !!res?.data?.ifCreateRoom || false;

        store.dispatch({
          type: 'set_user_is_black_room',
          data: { isBlackRoom },
        });

        callback && callback(isBlackRoom);
      })
      .catch((err) => {
        callback && callback(false);
      });
  }
};
